import {
    addDoc,
    arrayRemove,
    arrayUnion,
    collection,
    deleteDoc,
    deleteField,
    doc,
    endAt,
    endBefore,
    getDoc,
    getDocs, getFirestore,
    limit,
    onSnapshot,
    orderBy,
    query,
    setDoc,
    startAfter,
    startAt, Timestamp,
    updateDoc,
    where
} from 'firebase/firestore'
import {initializeApp} from "firebase/app";


const firebaseConfig = /*{
    apiKey: "AIzaSyB5lzpaicY7cFqdP7LsywMaCN7BNn7djAo",
    authDomain: "auftragsbuchchat.firebaseapp.com",
    projectId: "auftragsbuchchat",
    storageBucket: "auftragsbuchchat.appspot.com",
    messagingSenderId: "970010372089",
    appId: "1:970010372089:web:ee970ea7a6e71526097f28",
    measurementId: "G-04GZ88S4HZ"
};*/
    {apiKey: "AIzaSyAnY9JAPGSg80h_p-IGrMp6E8slsVy5a3w",
    authDomain: "auftragsbuchchat.firebaseapp.com",
    projectId: "auftragsbuchchat",
    storageBucket: "auftragsbuchchat.appspot.com",
    messagingSenderId: "970010372089",
    appId: "1:970010372089:web:619bd8d801ebf77a097f28",
    measurementId: "G-W1L1QDXP5Z"};

initializeApp(firebaseConfig)

export const firestoreDb = getFirestore()


const CUSTOMERS_PATH = 'customers'
const ROOMS_PATH = 'chat_rooms'
const MESSAGES_PATH = 'messages'
const PARTICIPANTS_PATH = 'participants'

const TIMESTAMP_FIELD = 'timestamp'
const UPDATE_DATE_FIELD = 'update_date'
const USERS_FIELD = 'users'

export const firestoreListener = onSnapshot


export const ROOM_PATH = customer_number => {
    return `${CUSTOMERS_PATH}/${customer_number}/${ROOMS_PATH}`
}
export const MESSAGE_PATH = (customer_number, room_id) => {
    return `${ROOM_PATH(customer_number)}/${room_id}/${MESSAGES_PATH}`
}

export const PARTICIPANT_PATH = (customer_number, room_id) => {
    return `${ROOM_PATH(customer_number)}/${room_id}/${PARTICIPANTS_PATH}`
}

const roomsRef = (customer_number) => {
    return collection(firestoreDb, ROOM_PATH(customer_number))
}

const messagesRef = (customer_number, roomId) => {
    return collection(firestoreDb, MESSAGE_PATH(customer_number, roomId))
}

const participantRef = (customer_number, roomId, user_id) => {
    return doc(firestoreDb, PARTICIPANT_PATH(customer_number, roomId), user_id)
}

const participantsRef = (customer_number, roomId) => {
    return collection(firestoreDb, PARTICIPANT_PATH(customer_number, roomId))
}

const getDocuments = query => {
    return getDocs(query).then(docs => {
        return { data: formatQueryDataArray(docs), docs: docs.docs }
    })
}

const getDocument = query => {
    return getDoc(query).then(doc => {
        return formatQueryDataObject(doc);
    })
}

export const getRooms = (customer_number, userId, roomsPerPage, lastLoadedRoom) => {
    if (lastLoadedRoom) {
        return getDocuments(
            query(
                roomsRef(customer_number),
                where(USERS_FIELD, "array-contains", userId),
                orderBy(UPDATE_DATE_FIELD, 'desc'),
                limit(roomsPerPage),
                startAfter(lastLoadedRoom)
            )
        )
    } else if (roomsPerPage) {
        return getDocuments(
            query(
                roomsRef(customer_number),
                where(USERS_FIELD, "array-contains", userId),
                orderBy(UPDATE_DATE_FIELD, 'desc'),
                limit(roomsPerPage)
            )
        )
    } else {
        return getDocuments(roomsRef(customer_number), where(USERS_FIELD, "array-contains", userId))
    }
}

export const getMessageCounter = (
    customer_number,
    roomId,
    user_id
) => {
    return getDocument(participantRef(customer_number, roomId, user_id))
}

export const getMessages = (customer_number, roomId, messagesPerPage, lastLoadedMessage) => {
    if (lastLoadedMessage) {
        return getDocuments(
            query(
                messagesRef(customer_number, roomId),
                orderBy(TIMESTAMP_FIELD, 'desc'),
                limit(messagesPerPage),
                startAfter(lastLoadedMessage)
            )
        )
    } else if (messagesPerPage) {
        return getDocuments(
            query(
                messagesRef(customer_number, roomId),
                orderBy(TIMESTAMP_FIELD, 'desc'),
                limit(messagesPerPage)
            )
        )
    } else {
        return getDocuments(messagesRef(customer_number, roomId))
    }
}

const formatQueryDataObject = queryData => {
    return { ...queryData.data(), id: queryData.id }
}

const formatQueryDataArray = queryDataArray => {
    const formattedData = []

    queryDataArray.forEach(data => {
        formattedData.push(formatQueryDataObject(data))
    })
    return formattedData
}


const formatQueryDataArrayMessagesLive = queryDataArray => {
    const formattedData = []

    queryDataArray.forEach(data => {
        formattedData.push(formatQueryDataObject(data.doc))
    })
    return formattedData
}

export const listenMessages = (
    customer_number,
    roomId,
    latestLoadedMessage,
    callback
) => {
    return firestoreListener(
        paginatedMessagesQuery(
            customer_number,
            roomId,
            latestLoadedMessage
        ),
        messages => {
            callback(formatQueryDataArrayMessagesLive(messages.docChanges()))
        }
    )
}

export const listenRooms = (
    customer_number,
    userId,
    roomsPerPage,
    callback
) => {
    if (!roomsPerPage) {
        roomsPerPage = 10;
    }
    return firestoreListener(
        query(
            roomsRef(customer_number),
            where(USERS_FIELD, "array-contains", userId),
            orderBy(UPDATE_DATE_FIELD, 'desc'),
            limit(roomsPerPage)
        ),
        rooms => {
            callback(rooms.docChanges())
        }
    )
}

export const listenParticipants = (
    customer_number,
    roomId,
    callback
) => {
    return firestoreListener(
        participantsRef(customer_number, roomId),
        parties => {
            callback(formatQueryDataArray(parties))
        }
    )
}

export const listenMessageCounter = (
    customer_number,
    roomId,
    user_id,
    callback
) => {
    return firestoreListener(
        participantRef(customer_number, roomId, user_id),
        parti => {
            callback(parti.data());
        }
    )
}

export const paginatedMessagesQuery = (
    customer_number,
    roomId,
    latestLoadedMessage
) => {
    if (latestLoadedMessage) {
        return query(
            messagesRef(customer_number,roomId),
            orderBy(TIMESTAMP_FIELD, 'desc'),
            endBefore(latestLoadedMessage)
        )
    }  else {
        return query(messagesRef(customer_number, roomId), orderBy(TIMESTAMP_FIELD, 'desc'))
    }
}

export const updateLastRead = (
    customer_number,
        roomId,
        user_id
) => {
    updateDoc(participantRef(customer_number, roomId, user_id), {count_unread: 0, last_active: Timestamp.fromDate(new Date())}).catch(err => console.log(err))
}

